/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_FeatureInputs */

const en_landing_footer_feature = /** @type {(inputs: Landing_Footer_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feature`)
};

const zh_landing_footer_feature = /** @type {(inputs: Landing_Footer_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`功能`)
};

/**
* | output |
* | --- |
* | "Feature" |
*
* @param {Landing_Footer_FeatureInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_footer_feature = /** @type {((inputs?: Landing_Footer_FeatureInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_FeatureInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_footer_feature(inputs)
	return zh_landing_footer_feature(inputs)
});
export { landing_footer_feature as "landing.footer.feature" }